module.exports = __webpack_public_path__ + "blur-bg.a42873d95a26afc7eb31.png";


//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/assets/images/widget/blur-bg.png
// module id = ../../../../../src/assets/images/widget/blur-bg.png
// module chunks = styles